import React from "react";
import { Link } from "wouter";

import { SCHEDULER_RUNS_NOTE } from "../../../constants";
import { SCHEDULERS_PATH } from "../../../paths";
import { ActionLink, Caption, Pill } from "../../../styles";
import { formatLastRun } from "../../../utils/format";
import {
  labelOfStatus,
  problemsFirst,
  toneOfStatus,
} from "../../../utils/status";
import {
  SchedulerFooter,
  SchedulerList as List,
  SchedulerName,
  SchedulerRow,
} from "../../styles";
import { AdminSection } from "../AdminSection";
import { SchedulerListProps } from "./types";

const OVERVIEW_ROW_COUNT = 3;

export const SchedulerList: React.FC<SchedulerListProps> = ({
  schedulers,
  onRetry,
}) => (
  <AdminSection
    title="Schedulers"
    section={schedulers}
    onRetry={onRetry}
    testId="admin-schedulers"
  >
    {(rows) => (
      <>
        <List>
          {problemsFirst(rows)
            .slice(0, OVERVIEW_ROW_COUNT)
            .map((scheduler) => (
              <SchedulerRow key={scheduler.name}>
                <div>
                  <SchedulerName>{scheduler.name}</SchedulerName>
                  <div>
                    <Caption>
                      {formatLastRun(scheduler.lastRunAt)}
                      {scheduler.lastOutcome && ` · ${scheduler.lastOutcome}`}
                      {scheduler.lastOutcome === "FAILURE" &&
                        scheduler.lastFailureErrorName &&
                        ` · ${scheduler.lastFailureErrorName}`}
                    </Caption>
                  </div>
                </div>
                <Pill $tone={toneOfStatus(scheduler.status)}>
                  {labelOfStatus(scheduler.status)}
                </Pill>
              </SchedulerRow>
            ))}
        </List>
        {rows.length > 0 && (
          <SchedulerFooter>
            <Link href={SCHEDULERS_PATH} asChild>
              <ActionLink>View all {rows.length} schedulers</ActionLink>
            </Link>
            <Caption>{SCHEDULER_RUNS_NOTE}</Caption>
          </SchedulerFooter>
        )}
      </>
    )}
  </AdminSection>
);
